import api from '@pray/shared/utils/api';

import type { SeedRunDetailResponse } from './types';

const RUNS_URL = '/web/studio/admin/seed-emails/runs';

/**
 * One run in full: the header, the setup, the seed ids "Use as base" re-ticks and the snapshot
 * the "What was sent" tab draws.
 *
 * The read never changes the run. The outcome callback moves the send cycle (the status); the
 * collect cycle moves the metrics and closes a send nobody confirmed in time.
 */
export async function getRun(runId: string) {
  const res = await api.executeGetRequest<{ data: SeedRunDetailResponse }>(`${RUNS_URL}/${runId}`);
  return res.data.data;
}
